export default {
  LOADING_GET_RESOURCES: 'LOADING_GET_RESOURCES',
  SUCCESS_GET_RESOURCES: 'SUCCESS_GET_RESOURCES',
  ERROR_GET_RESOURCES: 'ERROR_GET_RESOURCES',

  LOADING_GET_LANGUAGES: 'LOADING_GET_LANGUAGES',
  SUCCESS_GET_LANGUAGES: 'SUCCESS_GET_LANGUAGES',
  ERROR_GET_LANGUAGES: 'ERROR_GET_LANGUAGES',
} as const;
